import { useDispatch } from 'react-redux'
// import { signedOut } from 'store/slices/auth-slice'
import { useEffect } from 'react'
import { MY_RAYMAND_URL } from '../constants'
// import { useLogout } from 'api'

export function SignOut() {
  const dispatch = useDispatch()
  // const logout = useLogout()

  useEffect(() => {
    // logout().then(() => {
    // dispatch(signedOut())
    // localStorage.removeItem('token')
    // sessionStorage.removeItem('token')
    // })
    window.location.replace(`${MY_RAYMAND_URL}/panel/dashboard`)
  }, [dispatch])

  return null
}
